'use es6';

import get from 'hs-lodash/get';
import { NOT_REQUESTED } from 'forms-utils-lib/RequestState';
export const getFormGuid = () => {
  const formsHrefMatch = window.location.href.match('forms/[0-9]+/([a-z0-9-]+)/');
  return formsHrefMatch ? formsHrefMatch[1] : '';
};
export const getSubmissionBootstrapRequestState = state => get(state, `submissionsBootstrap.formSpecificItems[${getFormGuid()}].requestState`, NOT_REQUESTED);
export const getSubmissionBootstrapFields = state => get(state, `submissionsBootstrap.formSpecificItems[${getFormGuid()}].fields`, []);
export const getObjectTypeLabels = state => state.submissionsBootstrap.objectTypeLabels;